<template>
  <b-container>
    <b-row class="d-flex justif-content-center">
      <b-col md="12" class="mb-3">
        <div class="card text-white card-has-bg click-col">
          <img :src="img" :alt="alt" class="img-card"/>
          <div class="card-img-overlay d-flex flex-column">
            <div class="card-body">
              <h4 class="text-white">
                <slot name="p-1"></slot>
              </h4>
              <slot name="p-2"></slot>
            </div>
          </div>
        </div>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
export default {
  name: "C21",
  props: {
    img: {
      default: "https://picsum.photos/200/300",
    },
    alt: {
      default: "mixitweb",
    }
  },
};
</script>

<style scoped>
.card {
  border: none;
  transition: all 500ms cubic-bezier(0.19, 1, 0.22, 1);
  overflow: hidden;
  border-radius: 20px;
  height: 30rem;
  box-shadow: 0 0 12px 0 rgba(0, 0, 0, 0.2);
}

.img-card {
  position: absolute;
  top: 0;
  bottom: 0;
  right: 0;
  left: 0;
  height: 100%;
  width: 100%;
  object-fit: cover;
}

.card.card-has-bg {
  transition: all 500ms cubic-bezier(0.19, 1, 0.22, 1);
  background-size: 120%;
  background-repeat: no-repeat;
  background-position: center center;
}

.card.card-has-bg:before {
  content: "";
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background: inherit;
  -webkit-filter: grayscale(1);
  -moz-filter: grayscale(100%);
  -ms-filter: grayscale(100%);
  -o-filter: grayscale(100%);
  filter: grayscale(100%);
}

.card.card-has-bg:hover {
  transform: scale(0.98);
  box-shadow: 0 0 5px -2px rgba(0, 0, 0, 0.3);
  background-size: 130%;
  transition: all 500ms cubic-bezier(0.19, 1, 0.22, 1);
}

.card.card-has-bg:hover .card-img-overlay {
  transition: all 800ms cubic-bezier(0.19, 1, 0.22, 1);
  background: linear-gradient(0deg, rgba(var(--light-cyan), 0.25) 0%, var(--primary) 100%);
}

.card .card-footer {
  background: none;
  border-top: none;
}

.card .card-footer .media img {
  border: solid 3px rgba(234, 95, 0, 0.3);
}

.card .card-body {
  transition: all 500ms cubic-bezier(0.19, 1, 0.22, 1);
}

.card:hover {
  cursor: pointer;
  transition: all 800ms cubic-bezier(0.19, 1, 0.22, 1);
}

.card:hover .card-body {
  margin-top: 30px;
  transition: all 800ms cubic-bezier(0.19, 1, 0.22, 1);
}

.card .card-img-overlay {
  transition: all 800ms cubic-bezier(0.19, 1, 0.22, 1);
  background: var(--light-blue);
  background: linear-gradient(0deg, rgba(var(--light-cyan), 0) 0%, var(--primary) 100%);
}
</style>